module.exports = __webpack_public_path__ + "images/standard-d6fbcc12cf4fdb3ec67daf30d6b6c166.jpg";